// Auto sign-out after inactivity, with a warning shortly before.
import { useEffect, useRef, useState, useCallback } from 'react';

const IDLE_LIMIT_MS = 45 * 60 * 1000; // 45 minutes
const WARNING_BEFORE_MS = 60 * 1000; // warn 1 minute before

export function useIdleTimeout(onTimeout) {
  const [showWarning, setShowWarning] = useState(false);
  const cbRef = useRef(onTimeout);
  cbRef.current = onTimeout;
  const warnTimer = useRef(null);
  const logoutTimer = useRef(null);
  const warningActive = useRef(false);

  const reset = useCallback(() => {
    clearTimeout(warnTimer.current);
    clearTimeout(logoutTimer.current);
    warningActive.current = false;
    setShowWarning(false);
    warnTimer.current = setTimeout(() => {
      warningActive.current = true;
      setShowWarning(true);
    }, IDLE_LIMIT_MS - WARNING_BEFORE_MS);
    logoutTimer.current = setTimeout(() => {
      warningActive.current = false;
      setShowWarning(false);
      cbRef.current();
    }, IDLE_LIMIT_MS);
  }, []);

  useEffect(() => {
    const events = ['mousemove', 'mousedown', 'keydown', 'touchstart', 'scroll'];
    const handler = () => {
      if (!warningActive.current) reset();
    };
    events.forEach((e) => window.addEventListener(e, handler));
    reset();
    return () => {
      events.forEach((e) => window.removeEventListener(e, handler));
      clearTimeout(warnTimer.current);
      clearTimeout(logoutTimer.current);
    };
  }, [reset]);

  return { showWarning, stayActive: reset };
}
